export default {
    // GED Config
    getGedProviders:        { method: 'get',  url: 'institutions/{institutionId}/ged/providers' },
    getGedConfig:           { method: 'get',  url: 'institutions/{institutionId}/ged/config' },
    putGedConfig:           { method: 'put',  url: 'institutions/{institutionId}/ged/config' },
    postGedTestConnection:  { method: 'post', url: 'institutions/{institutionId}/ged/test-connection' },
    getGedTransfers:        { method: 'get',  url: 'institutions/{institutionId}/ged/transfers' },
    getGedStats:            { method: 'get',  url: 'institutions/{institutionId}/ged/stats' },
    postGedRetryTransfer:   { method: 'post', url: 'institutions/{institutionId}/ged/transfers/{transferId}/retry' },
}
